<template>
  <section>
    <nav class="columns">
      <div class="column">
        <b-field grouped group-multiline>
          <b-field>
            <b-select
              v-model="selectedArea"
              :loading="loadingAreas"
              :placeholder="
                $t('message.please_select') +
                  $t('attributes.area') +
                  '(' +
                  $t('attributes.is_promote') +
                  $t('attributes.count') +
                  ')'
              "
              @input="onSelectArea"
            >
              <option value="" disabled>
                {{
                  $t('message.please_select') +
                    $t('attributes.area') +
                    '(' +
                    $t('attributes.is_promote') +
                    $t('attributes.count') +
                    ')'
                }}
              </option>
              <option
                v-for="option in areas"
                :value="option"
                :key="option.code"
              >
                {{ option.name + '(' + option.promote_num + ')' }}
              </option>
            </b-select>
          </b-field>
          <b-field>
            <b-select
              v-model="selectedCatalog"
              :loading="loadingAreas"
              :disabled="catalogs.length <= 0"
              :placeholder="
                $t('message.please_select') + $t('attributes.catalog')
              "
              @input="onSelectCatalog"
            >
              <option value="">全部類別</option>
              <option
                v-for="option in catalogs"
                :key="option.catalog_no"
                :value="option"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field>
            <p class="control">
              <span class="button is-static">
                {{ $t('attributes.activation_status') }}
              </span>
            </p>
            <b-select v-model="filterStatus">
              <option value="">{{ $t('attributes.all') }}</option>
              <option value="true">{{ $t('attributes.shelve_on') }}</option>
              <option value="false">{{ $t('attributes.shelve_off') }}</option>
            </b-select>
          </b-field>
          <b-field>
            <p class="control">
              <span class="button is-static">
                {{ $t('attributes.is_promote') }}
              </span>
            </p>
            <b-select v-model="isHome">
              <option value="true">{{ $t('attributes.yes') }}</option>
              <option value="false">{{ $t('attributes.no') }}</option>
            </b-select>
          </b-field>
          <b-field>
            <b-datepicker
              :placeholder="
                $t('message.please_select') + $t('attributes.departure_date')
              "
              v-model="selectedDates"
              range
              @input="onSelectedDates"
            >
              <button class="button is-danger" @click="onClearDates">
                <b-icon icon="close"></b-icon>
                <span>Clear</span>
              </button>
            </b-datepicker>
          </b-field>
          <b-field>
            <b-input
              v-model="searchCode"
              :placeholder="
                $t('attributes.search') + $t('attributes.group_code')
              "
              type="search"
              icon="magnify"
            ></b-input>
          </b-field>
          <b-field>
            <b-input
              v-model="searchName"
              :placeholder="$t('attributes.search') + $t('attributes.name')"
              type="search"
              icon="magnify"
            ></b-input>
          </b-field>
        </b-field>
      </div>
      <div class="column is-1">
        <div class="buttons is-right">
          <b-button
            :loading="loadingSearch"
            class="is-primary"
            @click="onSearch"
          >
            {{ $t('attributes.search') }}
          </b-button>
        </div>
      </div>
    </nav>
    <div v-for="item in items" :key="item.code">
      <recently-hot-travel-group-form
        :travel-group="item"
        @updated="onUpdated"
      />
    </div>
  </section>
</template>

<script>
import { HOME_RECENTLY_HOT_API, TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import RecentlyHotTravelGroupForm from '@/components/home/RecentlyHotTravelGroupForm'

export default {
  name: 'RecentlyHotTravelGroups',
  components: { RecentlyHotTravelGroupForm },
  data() {
    const { query } = this.$route
    let startDate = null
    let endDate = null
    let selectedDates = []

    if (query.start && query.end) {
      startDate = this.$dayjs.unix(query.start).toDate()
      endDate = this.$dayjs.unix(query.end).toDate()
      selectedDates = [startDate, endDate]
    }

    return {
      loadingAreas: false,
      loadingSearch: false,

      sortField: query.sort || 'code',
      sortOrder: query.order || 'asc',
      defaultSortOrder: 'asc',
      page: query.page || 1,
      perPage: query.page_size || 50,
      total: 0,

      areas: [],
      catalogs: [],
      selectedArea: '',
      selectedCatalog: '',
      filterStatus: '',
      isHome: true,
      searchCode: '',
      searchName: '',

      selectedDates,
      startDate,
      endDate,

      selectedItem: null,
      items: []
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    async loadAreas() {
      this.loadingAreas = true

      const api = `${HOME_RECENTLY_HOT_API}/is-promo-areas`
      const res = await this.axios.get(api)
      this.areas = res.data.data
      this.catalogs = []
      this.selectedArea = null
      this.selectedCatalog = null

      this.loadingAreas = false
    },
    onSelectArea(option) {
      this.loadingAreas = true

      this.selectedArea = option
      this.catalogs = option ? option.catalogs.sort(c => c.sort) : []
      this.selectedCatalog = null

      this.loadingAreas = false
    },
    onSelectCatalog(option) {
      this.selectedCatalog = option
    },
    onSelectedDates() {
      this.startDate = this.selectedDates[0]
      this.endDate = this.selectedDates[1]
    },
    onClearDates() {
      this.selectedDates = null
      this.startDate = null
      this.endDate = null
    },
    async onSearch() {
      const api = TRAVEL_GROUPS_API

      const params = {
        is_collaborate: false,
        area_code: this.selectedArea != null ? this.selectedArea.code : '',
        catalog_no:
          this.selectedCatalog != null ? this.selectedCatalog.code : '',
        type: '一般',
        active: this.filterStatus && this.filterStatus === 'true',
        start_date: this.startDate,
        end_date: this.endDate,
        show_expired: false,
        is_home: this.isHome,
        search_code: this.searchCode,
        search: this.searchName,
        sort_by: this.sortField,
        by_descending: this.sortOrder !== 'asc',
        page_size: this.perPage,
        page_number: this.page
      }

      try {
        this.loadingSearch = true

        if (this.selectedArea === null) {
          notifyService.show('請選擇線別')
        } else {
          const res = await this.axios.get(api, { params })
          const data = res.data.data

          this.items = data.items
          this.total = data.item_count
        }
      } catch (e) {
        this.items = []
        this.total = 0

        notifyService.fetch_error('travel_group', e)
      } finally {
        this.loadingSearch = false
      }
    },
    onUpdated(group) {
      this.$emit('updated', group)
    }
  }
}
</script>
